import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1>About Musespace</h1>
            <p>Creating spaces that inspire, function, and delight since 2020</p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section mission-section">
        <div className="container">
          <div className="grid grid-2">
            <div className="mission-content">
              <h2>Our Mission</h2>
              <p>
                At Musespace, we believe that great design has the power to transform lives. 
                Our mission is to create spaces that not only look beautiful but also enhance 
                the way people live, work, and interact with their environment.
              </p>
              <p>
                We combine creativity with functionality, ensuring that every project we undertake 
                reflects our commitment to excellence and attention to detail.
              </p>
              <div className="mission-values">
                <div className="value-item">
                  <span className="value-icon">🎨</span>
                  <div>
                    <h4>Creativity</h4>
                    <p>Innovative design solutions that push boundaries</p>
                  </div>
                </div>
                <div className="value-item">
                  <span className="value-icon">⚡</span>
                  <div>
                    <h4>Excellence</h4>
                    <p>Uncompromising quality in every project</p>
                  </div>
                </div>
                <div className="value-item">
                  <span className="value-icon">🤝</span>
                  <div>
                    <h4>Collaboration</h4>
                    <p>Working closely with clients to achieve their vision</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mission-image">
              <div className="image-placeholder">
                <span>🏢</span>
                <p>Professional Excellence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">4+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section process-section">
        <div className="container">
          <div className="section-title">
            <h2>Our Process</h2>
            <p>How we bring your vision to life</p>
          </div>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Discovery</h3>
              <p>We start by understanding your vision, needs, and budget to create a tailored approach.</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Concept Design</h3>
              <p>Our team develops initial concepts and presents multiple design options for your review.</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Development</h3>
              <p>We refine the chosen concept with detailed drawings, specifications, and material selections.</p>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h3>Execution</h3>
              <p>Our experienced team manages the construction process to ensure quality and timely delivery.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 